var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 6.66634V14.9997C19.1673 15.9163 18.4173 16.6663 17.5006 16.6663H4.16732C3.70898 16.6663 3.33398 16.2913 3.33398 15.833C3.33398 15.3747 3.70898 14.9997 4.16732 14.9997H17.5006V6.66634C17.5006 6.20801 17.8756 5.83301 18.334 5.83301C18.7923 5.83301 19.1673 6.20801 19.1673 6.66634ZM3.33398 13.333C1.95065 13.333 0.833984 12.2163 0.833984 10.833V5.83301C0.833984 4.44967 1.95065 3.33301 3.33398 3.33301H13.334C14.7173 3.33301 15.834 4.44967 15.834 5.83301V11.6663C15.834 12.583 15.084 13.333 14.1673 13.333H3.33398ZM5.83398 8.33301C5.83398 9.71634 6.95065 10.833 8.33398 10.833C9.71732 10.833 10.834 9.71634 10.834 8.33301C10.834 6.94967 9.71732 5.83301 8.33398 5.83301C6.95065 5.83301 5.83398 6.94967 5.83398 8.33301Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvance);
export default __webpack_public_path__ + "static/media/advance.74e63a4f32dc3bbe29ef62670c328aad.svg";
export { ForwardRef as ReactComponent };